/* eslint-disable react/prop-types */
import { Box, Button, Card, CardContent, Chip, Grid, Stack, Typography } from '@mui/material';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------
export default function ExamSection({ exams }) {
  const router = useRouter();

  const random = () => {
    const idx = getRandomInt(0, exams.length - 1);
    const slug = exams[idx].slug;
    router.push(`/thi-tinh-huong/thi-thu/${slug}`);
  };

  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  return (
    <Stack alignItems="center" mb={2}>
      <Grid container alignItems={"center"} px={2}>
        <Box>
          <Button onClick={random} variant={"outlined"} size="medium" sx={{ px: 2, py: 1, borderRadius: 1 }} >Đề ngẫu nhiên</Button>
        </Box>
        {exams.map((e) => (
          <ExamItem key={e.id} item={e} />
        ))}
      </Grid>
    </Stack >
  );
}

function ExamItem({ item }) {
  const router = useRouter();
  const pathname = router.asPath.replace("/thi-tinh-huong/thi-thu/", '').replace("/", '');

  const { slug, title } = item;

  const isActive = pathname === slug;

  const { exams } = useSelector((state) => state.examS);

  const exam = exams?.find(e => e.id === item.id);

  const total = exam?.examSituations.map(item => item.score || 0).reduce((a, b) => a + b, 0);

  return (
    <Link href={`/thi-tinh-huong/thi-thu/${slug}`} passHref >
      <Card variant='outlined' sx={{ m: 1, cursor: 'pointer', borderRadius: 1 }}>
        <CardContent sx={{ py: 1, px: 2, ":last-child": { paddingBottom: 1 } }} >
          <Stack direction={'row'} spacing={1} justifyItems={"center"} alignItems={"center"}>
            <Typography><Iconify icon={'material-symbols:star-rate'} style={{ color: isActive ? 'orange' : 'grey' }} /></Typography>
            <Typography variant='subtitle2'> {title}</Typography>
            {exam && <>
              {total >= 35 ? <Chip variant='outlined' label="ĐẠT" color='primary' size='small' /> :
                <Chip variant='outlined' label="TRƯỢT" color="error" size='small' />}
            </>}
          </Stack>
        </CardContent>
      </Card>
    </Link>
  );
}
